/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.credentials.rpc.PlaylistVisibilityChirpService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getAllUserPlaylistProgressRpc = {
  serviceName: 'com.hubspot.learning.center.credentials.rpc.PlaylistVisibilityChirpService',
  rpcName: 'getAllUserPlaylistProgress',
  auth: 'app',
  fingerprint: '6bUoT9laXD4-PqQ3OZNH95wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAssignedPlaylistsForPortalRpc = {
  serviceName: 'com.hubspot.learning.center.credentials.rpc.PlaylistVisibilityChirpService',
  rpcName: 'getAssignedPlaylistsForPortal',
  auth: 'app',
  fingerprint: 'qmxDPFiFjyHRtvvjI7RhIZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};